import { isWeb, YStack, H2 } from '@mythical/ui'
import { RenderBlocks } from 'app/components/blocks/RenderBlocks'
import ContentGrid from 'app/components/content/ContentGrid'
import { ButtonLink } from 'app/components/primitive/Button'
import { Meta } from 'app/components/primitive/Meta'
import MainLayout from 'app/components/structure/Layout/MainLayout'
import SectionIntro from 'app/components/structure/SectionIntro'
import useCollectionPage from 'app/hooks/use-collection-page'
import { createParam } from 'solito'
import { CollectionType } from 'app/queries/collections/collection-fragment'
import React from 'react'

const { useParam } = createParam<{ slug: string }>()

export function CollectionScreen({ type }: { type: CollectionType }) {
  const [slug] = useParam('slug')
  const [showContent, setShowContent] = React.useState(false)

  // FIXME: Not the ideal solution to the scroll issue
  React.useEffect(() => {
    setShowContent(true)
  }, [])

  const { pagination, featured, collection } = useCollectionPage(
    type,
    (slug as string) || ''
  )

  const title = slug === 'initiate' ? 'Initiate' : collection?.title

  return (
    <MainLayout
      contentStyles={{
        bg: '$secondary10',
        flexGrow: 1,
      }}
      showBackBtn
      noScroll={!isWeb}
      noBottomTabs
    >
      <Meta title={title} type={type} slug={slug} />
      <SectionIntro
        title={title || ''}
        description={collection?.subtitle || ''}
      />
      {isWeb && (
        <RenderBlocks
          blocks={collection?.content || []}
          collectionType={type}
          collectionId={collection?.id}
          featuredPosts={featured || []}
          isPage
          slug={slug}
          backgroundColor="$secondary10"
          spaced
        />
      )}
      {!pagination.loading &&
        pagination.isFetchedAfterMount &&
        !pagination.hasMore &&
        !collection && (
          <YStack space="$3" jc="center" ai="center">
            <H2
              textAlign="center"
              color="$primary1"
              textTransform="uppercase"
              size="$7"
              fontWeight="500"
              $gtSm={{
                size: '$8',
                fontWeight: '500',
              }}
            >
              Oops! something’s wrong here
            </H2>
            <ButtonLink href="/">Reload Homepage</ButtonLink>
          </YStack>
        )}

      {showContent && <ContentGrid
        hasMore={pagination?.hasMore}
        loadMore={() => pagination?.fetchMore()}
        items={pagination?.data?.docs}
        loading={pagination?.loading}
        isFetchingNextPage={pagination?.isFetchingNextPage}
        FlatListHeader={
          !isWeb ? (
            <RenderBlocks
              blocks={collection?.content || []}
              collectionType={type}
              featuredPosts={featured || []}
              collectionId={collection?.id}
              backgroundColor="$secondary10"
              spaced
            />
          ) : null
        }
        flatList
      />}
    </MainLayout>
  )
}
